import AIAssistedNote from './AIAssistedNote';

export default AIAssistedNote;
